import * as React from 'react';
import { EditVacationTypeDialogModel } from './model/EditVacationTypeDialogModel';
import { GeneralSettingsController } from './controller/GeneralSettingsController';
import { Dialog } from 'components/dialog';
import { TextField } from 'components/input/TextField';
import { Icon, Button } from '@material-ui/core';

export class EditVacationTypeDialog extends React.Component<Props, State> {

    private static readonly colors: string[] = ["#81c784", "#f06292", "#ba68c8", "#9575cd", "#7986cb", "#e57373", "#4fc3f7", "#64b5f6", "#a1887f",
        "#4dd0e1", "#4db6ac", "#aed581", "#dce775", "#fff176", "#ffd54f", "#ffb74d", "#ff8a65", "#e0e0e0", "#90a4ae"];

    public constructor(props: Props) {
        super(props);

        this.state = { selectedColor: props.model.color, name: props.model.name };

        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleCancelButtonClicked = this.handleCancelButtonClicked.bind(this);
        this.handleSaveButtonClicked = this.handleSaveButtonClicked.bind(this);
    }

    private handleNameChange(newValue: string) {
        this.setState({ name: newValue })
    }

    private handleCancelButtonClicked() {
        this.props.controller.onCancelEditVacationTypeClicked();
    }

    private handleSaveButtonClicked() {
        this.props.controller.onSaveVacationTypeClicked(this.props.model.id, this.state.name, this.state.selectedColor);
    }

    public render() {
        if (this.props.model == null) {
            return (<div></div>);
        }

        return (
            <Dialog title={this.props.model.id == null ? "Add vacation type" : "Edit vacation type"} error={this.props.model.error} >
                <TextField label="Name" value={this.state.name} desc="The visible name of this vacation type" onChange={this.handleNameChange} />
                {this.renderColorPicker()}
                {this.renderActions()}
            </Dialog>
        );
    }

    private renderColorPicker() {
        return (
            <div style={{ width: '100%', marginBottom: '24px' }}>
                <div style={{ fontSize: '14px', fontWeight: 600, color: '#222' }}>Color</div>
                <div style={{ width: '100%', verticalAlign: 'top', marginTop: '2px' }}>
                    {EditVacationTypeDialog.colors.map((color, index) => {
                        return (
                            <div
                                key={"colorbox-" + index}
                                style={{
                                    display: 'inline-block',
                                    width: '30px',
                                    height: '30px',
                                    backgroundColor: color,
                                    margin: '5px',
                                    cursor: 'pointer',
                                    verticalAlign: 'top',
                                    padding: '5px'
                                }}
                                onClick={() => { this.setState({ selectedColor: color }) }}
                            >
                                {this.state.selectedColor == color && (
                                    <Icon style={{ fontSize: '18px', color: "#fff" }}>done</Icon>
                                )}
                            </div>
                        );
                    })}
                </div>
            </div>
        )
    }

    private renderActions() {
        return (
            <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '100%' }}>
                <Button color="secondary" onClick={this.handleCancelButtonClicked}>Cancel</Button>
                <Button style={{ marginLeft: '8px' }} color="primary" variant="contained" onClick={this.handleSaveButtonClicked}>Save</Button>
            </div>
        )
    }

}

export interface Props {

    model: EditVacationTypeDialogModel;
    controller: GeneralSettingsController;

}

interface State {

    selectedColor: string;
    name: string;

}